// API URL configuration
export const API_URL = process.env.NODE_ENV === 'development' 
    ? 'http://localhost:4000/api'
    : 'https://www.414ministry.org/api'; 